module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-247.6fddbe82.svg";